export default __webpack_public_path__ + "static/media/i-icon-light.d9330d7f.svg";